import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button';

import Api from "../../../libraries/api";
import { history } from "../../../shared/configure-store";
import AuthHelper from "../../../libraries/auth-helper";

const validator = new SimpleReactValidator({
    messages: {
        required: 'Field ini wajib diisi',
        email: 'Format email tidak valid',
        min: 'Nomor telepon minimal 8 digit',
    }
});

class CompanyAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingButton: false,
            errors: {},
            name: '',
            name_in_region: '',
            email: '',
            phone: '',
            address: '',
            isManage: false,
        };
    }

    componentDidMount() {
        document.title = 'Gudangemas - Buat Company';
        let profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            let roles = profile['map-menu'].map(o => ({
                id: o.id,
                name: o.menu.name,
                isManage: o.isManage,
            }));

            // TODO: FIX PERMISSION TO COMPANY
            let all = roles.filter(item => item.name === 'Customer');

            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });
        }
    }

    handleChange = (e, prop) => {
        this.setState({ [prop]: e.target.value });
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });
    
    handleSubmit = (e) => {
        e.preventDefault();
        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return;
        }

        this.setState({ loadingButton: true });

        const params = {
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            address: this.state.address
        };

        Api.post('/company', params)
            .then(resp => {
                toast.success('Company berhasil ditambahkan');
                history.push('/companies');
            })
            .catch(err => {
                this.setState({ loadingButton: false });
            });
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Buat Company</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/admins" >Company</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Tambah</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>Tambah Company</h2>
                            </div>
                        </div>
                        <h3 className='section-title'> </h3>
                        <form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Nama Company</label>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            value={this.state.name}
                                            onChange={(e) => this.handleChange(e, 'name')}
                                            error={this.state.errors.name}
                                            helperText={this.state.errors.name}
                                        />
                                        {validator.message('name', this.state.name, 'required')}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Email</label>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            value={this.state.email}
                                            error={this.state.errors.email}
                                            helperText={this.state.errors.email}
                                            onChange={(e) => this.handleChange(e, 'email')}
                                        />
                                        {validator.message('email', this.state.email, 'email|required')}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Telepon</label>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            type="number"
                                            value={this.state.phone}
                                            error={this.state.errors.phone}
                                            helperText={this.state.errors.phone}
                                            onChange={(e) => this.handleChange(e, 'phone')}
                                        />
                                        {validator.message('phone', this.state.phone, 'min:8|required')}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Alamat</label>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            multiline
                                            rows={3}
                                            value={this.state.address}
                                            error={this.state.errors.address}
                                            helperText={this.state.errors.address}
                                            onChange={(e) => this.handleChange(e, 'address')}

                                        />
                                        {validator.message('address', this.state.address, 'required')}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-center mt-4">
                                    <Button
                                        variant="contained"
                                        onClick={() => history.push('/companies')}
                                        className="mr-3"
                                    >
                                        Batal
                                    </Button>
                                    {this.state.isManage && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            disabled={this.state.loadingButton}
                                        >
                                            Simpan
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default CompanyAdd;